import { useRequestorStore } from '../../stores/requestorStore';
import { getDate, getTime } from '../../utils/commonUtils';
import StagesStepper from '../../components/StagesStepper';
import { ModelStatuses } from '../../utils/enums';

const RequestDetails = () => {
    const activeRequest = useRequestorStore((state) => state.activeRequest);
    const productsCount = activeRequest?.products?.length || 0;
    let approvedProductsCount = 0;
    activeRequest?.products?.forEach((p) => {
        if (p.status === ModelStatuses.APPROVED) {
            approvedProductsCount += 1;
        }
    });

    return (
        <div className="h-full p-8 overflow-scroll">
            <h1 className="text-xl font-semibold text-black mb-6">{activeRequest?.id}</h1>
            <div className="flex justify-between gap-3 mb-10">
                <div>
                    <div className="text-gray-500 whitespace-no-wrap text-xs uppercase mb-1">requested by</div>
                    <div className="whitespace-no-wrap text-base capitalize text-blue-700">{activeRequest?.user?.username}</div>
                </div>
                <div>
                    <div className="text-gray-500 whitespace-no-wrap text-xs uppercase mb-1">date</div>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{getDate(activeRequest?.createdAt)}</div>
                </div>
                <div>
                    <div className="text-gray-500 whitespace-no-wrap text-xs uppercase mb-1">time</div>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{getTime(activeRequest?.createdAt)}</div>
                </div>
            </div>
            <div className="mb-10">
                <h1 className="text-gray-900 whitespace-no-wrap text-base uppercase mb-4">FSN Details</h1>
                <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Total FSN</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{productsCount} Products</div>
                </div>
                <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Approved</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{approvedProductsCount} Products</div>
                </div>
                {/* <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Rejected</div>:<div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">0 Products</div>
                </div> */}
                <div className="flex mb-2">
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize w-36">Pending</div>:
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize w-36 text-right">{productsCount - approvedProductsCount} Products</div>
                </div>
            </div>
            <div>
                <h1 className="text-gray-900 whitespace-no-wrap text-base uppercase mb-4">Stage</h1>
                <StagesStepper data={activeRequest} />
            </div>
        </div>
    );
};

export default RequestDetails;
